module.exports = __webpack_public_path__ + "img/wechant-success.a872738d.png";